import { useEffect, useRef, useState } from "react";
import { api } from "../../lib/api";

const GROUPS = [["places", "Byer og postnumre"], ["services", "Behandlinger"], ["clinics", "Klinikker"]];

// Accessible combobox with grouped Danish autocomplete (places, treatments, clinics)
export const Autocomplete = ({ id, label, value, onChange, onSelect, groups = ["places"], placeholder, species, testid }) => {
  const [data, setData] = useState(null);
  const [open, setOpen] = useState(false);
  const [active, setActive] = useState(-1);
  const timer = useRef();
  useEffect(() => {
    clearTimeout(timer.current);
    if (!open || !value || value.trim().length < 1) { setData(null); return undefined; }
    timer.current = setTimeout(() => {
      api.get("/public/autocomplete", { params: { q: value.trim(), species } }).then((r) => setData(r.data)).catch(() => setData(null));
    }, 180);
    return () => clearTimeout(timer.current);
  }, [value, open, species]);
  const items = data ? GROUPS.filter(([g]) => groups.includes(g)).flatMap(([g]) => (data[g] || []).map((o) => ({ ...o, group: g }))) : [];
  const pick = (o) => { onSelect(o.group, o.value, o.label); setOpen(false); setActive(-1); };
  const onKey = (e) => {
    if (!items.length) return;
    if (e.key === "ArrowDown") { e.preventDefault(); setActive((a) => (a + 1) % items.length); }
    else if (e.key === "ArrowUp") { e.preventDefault(); setActive((a) => (a <= 0 ? items.length - 1 : a - 1)); }
    else if (e.key === "Enter" && active >= 0) { e.preventDefault(); pick(items[active]); }
    else if (e.key === "Escape") setOpen(false);
  };
  return (
    <div className="relative">
      {label && <label htmlFor={id} className="block text-xs font-semibold text-[#52706D] mb-1.5">{label}</label>}
      <input id={id} className="field-vp" value={value} placeholder={placeholder} autoComplete="off" role="combobox" aria-expanded={open && items.length > 0}
        aria-controls={`${id}-list`} aria-activedescendant={active >= 0 ? `${id}-opt-${active}` : undefined}
        onChange={(e) => { onChange(e.target.value); setOpen(true); setActive(-1); }} onFocus={() => setOpen(true)} onBlur={() => setTimeout(() => setOpen(false), 150)}
        onKeyDown={onKey} data-testid={testid} />
      {open && items.length > 0 && (
        <ul id={`${id}-list`} role="listbox" className="absolute z-[1100] mt-1 w-full max-h-72 overflow-auto rounded-xl border border-[#D7E7E3] bg-white shadow-lg py-1" data-testid={`${testid}-list`}>
          {items.map((o, i) => (
            <li key={`${o.group}-${o.value}`} id={`${id}-opt-${i}`} role="option" aria-selected={i === active}
              onMouseDown={(e) => { e.preventDefault(); pick(o); }} data-testid={`${testid}-option-${o.group}-${o.value}`}
              className={`px-3 py-2 text-sm cursor-pointer flex justify-between gap-2 ${i === active ? "bg-[#E6F4EF]" : "hover:bg-[#F7FAF9]"}`}>
              <span className="text-[#153C3A]">{o.label}</span><span className="text-[10px] uppercase tracking-wide text-[#52706D]">{GROUPS.find(([g]) => g === o.group)[1]}</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
